module.exports = __webpack_public_path__ + "img/101012.489791a4.png";